import React from 'react';
import PrivateRoute from 'PrivateRoutes';
import { Components } from './components';

const routes = () => (
  <PrivateRoute exact path="/settings/config" component={Components} />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/Config/routes.js